<script setup lang="ts">
import socialLinks from '~/constants/social-links'

const route = useRoute()

const items = computed(() => {
  const items = [{
    label: 'Home',
    to: '/',
  }, {
    label: 'Onderzoek',
    to: '/onderzoek',
    active: route.path.startsWith('/onderzoek'),
  }, {
    label: 'Doe Mee',
    to: '/doe-mee',
  }, {
    label: 'Contact',
    to: '/contact',
  }]

  if (import.meta.dev) {
    items.push({
      label: 'Tools',
      to: '/tools',
    })
  }

  return items
})
</script>

<template>
  <UHeader
    class="dark"
    :ui="{
      root: 'dark:bg-blue-900 border-b dark:border-b-blue-950 shadow-neutral-950/40 shadow-lg',
    }"
  >
    <template #left>
      <ApplicationHeaderNavigationLogoLink />
    </template>
    <template #default>
      <UNavigationMenu
        :items="items"
        highlight
        highlight-color="primary"
        orientation="horizontal"
      />
    </template>

    <template #body>
      <UNavigationMenu
        highlight
        highlight-color="primary"
        :items="items"
        orientation="vertical"
        class="dark -mx-2.5"
      />
    </template>

    <template #right>
      <UButton
        v-for="link in socialLinks"
        :key="link.label"
        :href="link.url"
        variant="ghost"
        :icon="link.icon"
        size="xs"
      />
      <DonateModal>
        <UButton variant="ghost">
          Doneren
        </UButton>
      </DonateModal>
      <UColorModeButton />
    </template>
  </UHeader>
</template>
